(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["eos-category-circles"] && !Shopify.designMode) return;
  try {
    
(() => {
  document.querySelectorAll('[data-eos-category-carousel]').forEach((section) => {
    const viewport = section.querySelector('.eos-category-circles__grid');
    if (!viewport) return;
    const move = (direction) => viewport.scrollBy({left: direction * viewport.clientWidth, behavior: 'smooth'});
    section.querySelector('[data-eos-category-prev]')?.addEventListener('click', () => move(-1));
    section.querySelector('[data-eos-category-next]')?.addEventListener('click', () => move(1));
    if (section.dataset.showArrows !== 'true') section.querySelectorAll('.eos-category-circles__arrow').forEach((arrow) => arrow.hidden = true);
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["eos-footer"] && !Shopify.designMode) return;
  try {
    
(() => {
  document.querySelectorAll('.eos-footer').forEach((footer) => {
    const columns = [...footer.querySelectorAll('.eos-footer__column')];
    columns.forEach((column) => {
      const toggle = column.querySelector('.eos-footer__toggle');
      if (!toggle) return;
      toggle.addEventListener('click', () => {
        if (window.innerWidth >= 750) return;
        const isOpen = column.classList.toggle('is-open');
        toggle.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
      });
    });
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["eos-image-slider"] && !Shopify.designMode) return;
  try {
    
(() => {
  document.querySelectorAll('[data-eos-slider]').forEach((slider) => {
    if (slider.dataset.initialized === 'true') return;
    slider.dataset.initialized = 'true';
    const track = slider.querySelector('.eos-image-slider__track');
    const slides = [...slider.querySelectorAll('[data-eos-slide]')];
    const dots = [...slider.querySelectorAll('[data-eos-dot]')];
    if (!track || slides.length < 1) return;
    let current = 0;
    let timer;
    const loop = slider.dataset.loop === 'true';
    const update = (index) => {
      current = index;
      track.style.transform = `translateX(-${current * 100}%)`;
      dots.forEach((dot, dotIndex) => {
        const active = dotIndex === current;
        dot.classList.toggle('is-active', active);
        dot.setAttribute('aria-selected', active ? 'true' : 'false');
      });
    };
    const move = (direction) => {
      if (slides.length < 2) return;
      const next = current + direction;
      update(loop ? (next + slides.length) % slides.length : Math.max(0, Math.min(slides.length - 1, next)));
    };
    const start = () => {
      if (slider.dataset.autoplay !== 'true' || slides.length < 2) return;
      clearInterval(timer);
      timer = setInterval(() => move(1), Math.max(3, Number(slider.dataset.speed) || 5) * 1000);
    };
    slider.querySelector('[data-eos-prev]')?.addEventListener('click', () => { move(-1); start(); });
    slider.querySelector('[data-eos-next]')?.addEventListener('click', () => { move(1); start(); });
    dots.forEach((dot) => dot.addEventListener('click', () => { update(Number(dot.dataset.eosDot)); start(); }));
    slider.addEventListener('mouseenter', () => clearInterval(timer));
    slider.addEventListener('mouseleave', start);
    update(0);
    start();
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["eos-new-arrivals"] && !Shopify.designMode) return;
  try {
    
(() => {
  document.querySelectorAll('.eos-arrivals__wishlist').forEach((button) => {
    if (button.dataset.initialized === 'true') return;
    button.dataset.initialized = 'true';
    button.addEventListener('click', (event) => {
      event.preventDefault();
      event.stopPropagation();
      button.classList.toggle('is-active');
      button.textContent = button.classList.contains('is-active') ? '♥' : '♡';
    });
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["eos-testimonials"] && !Shopify.designMode) return;
  try {
    (()=>{document.querySelectorAll('.eos-testimonials').forEach(s=>{const t=s.querySelector('.eos-testimonials__track'),c=t?.querySelector('.eos-testimonials__card');if(!t||!c)return;const m=d=>{const x=c.getBoundingClientRect().width+parseFloat(getComputedStyle(t).gap||0);if(d>0&&t.scrollLeft+t.clientWidth>=t.scrollWidth-4)t.scrollTo({left:0,behavior:'smooth'});else t.scrollBy({left:d*x,behavior:'smooth'})};s.querySelector('[data-prev]')?.addEventListener('click',()=>m(-1));s.querySelector('[data-next]')?.addEventListener('click',()=>m(1));if(s.dataset.autoplay==='true'&&!matchMedia('(prefers-reduced-motion: reduce)').matches)setInterval(()=>m(1),Number(s.dataset.speed)||4000)})})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
      this.setHeaderHeight = this.setHeaderHeight.bind(this);
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.mobileMediaQuery = window.matchMedia('(max-width: 990px)');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      this.mobileMediaQuery.addEventListener('change', this.setHeaderHeight);

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearches = this.querySelectorAll('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.mobileMediaQuery.removeEventListener('change', this.setHeaderHeight);
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if ([...this.predictiveSearches].some((predictiveSearch) => predictiveSearch.isOpen)) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModals = this.searchModals || this.header.querySelectorAll('details-modal');
      this.searchModals.forEach((searchModal) => searchModal.close(false));
    }
  }

  // The account `open` event is composed but does not bubble, so listen during capture.
  // Anchor the dialog to the bottom of the account button itself. The header group can be
  // much taller than the button's row (for example, a top-left logo pushes the menu to a
  // second row), so anchoring to the section bottom drops the dialog too low.
  document.addEventListener(
    'open',
    (event) => {
      if (!(event.target instanceof HTMLElement) || !event.target.matches('shopify-account')) return;

      const bottom = Math.max(0, Math.round(event.target.getBoundingClientRect().bottom));
      event.target.style.setProperty('--account-dialog-top', `${bottom}px`);
    },
    true
  );

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
